module.exports = __webpack_public_path__ + "assets/2299d37ad795cf62bb8cebe986791fed.svg";